<article class="fui-card" (click)="cardClick.emit()">
  <div class="fui-card-body">
    @if (image) {
      <figure
        class="fui-card-image"
        (click)="imageClick.emit()"
        [ngStyle]="{
          aspectRatio: imageAspectRatio,
          backgroundImage: imageAsBackground ? 'url(' + image + ')' : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
        }"
      >
        @if (!imageAsBackground) {
          <img [src]="image" />
        }
      </figure>
    }
    @if (progress != undefined) {
      <div class="video-progress">
        <div
          class="progress-bar progress-indicator"
          role="progressbar"
          [ngStyle]="{ width: progress + '%' }"
          attr.aria-valuenow="{{ progress }}"
          aria-valuemin="0"
          aria-valuemax="100"
          aria-busy="false"
          [attr.aria-label]="title + ' progress: '"
        ></div>
      </div>
    }
    <section class="fui-card-content">
      <span class="card-title" (click)="titleClick.emit()">{{ title }}</span>
      @if (text) {
        <div class="fui-card-description">{{ text }}</div>
      }
      <ng-content></ng-content>
    </section>
  </div>
</article>
